@if (visible()) {
  @if (banner$ | async; as banner) {
    <div
      class="banner d-print-none"
      [ngClass]="['justify-content-' + content()]"
    >
      <div
        class="banner-container"
        [style.max-width]="maxWidth()"
      >

        @if (withCloseButton()) {
          <button
            type="button"
            class="banner-close-button"
            data-testid="catfishAdvertBanner_close"
            (click)="close()"
          >
            <i class="far fa-window-close"></i>
          </button>
        }

        @if (banner.link) {
          <a
            target="_blank"
            rel="noopener noreferrer"
            [attr.href]="banner.link"
          >
            <img
              class="img-fluid"
              [style.max-height]="maxHeight()"
              [src]="banner.imageUrl"
              [alt]="banner.altText"
            />
          </a>
        } @else {
          <img
            class="img-fluid"
            [style.max-height]="maxHeight()"
            [src]="banner.imageUrl"
            [alt]="banner.altText"
          />
        }
      </div>
    </div>
  }
}
